// extracted by mini-css-extract-plugin
module.exports = {"page":"notFound_page__2ieSC","pageInner":"notFound_page-inner__1EmTJ"};